import React, { useState } from "react";
import { Text } from "@/styles/reactnative";
import { CryptoPriceHeader, CryptoPriceSection } from "./styles";
import MarketTrendTabs from "../../MarketTrendTabs";
import CryptoPriceGraph from "./CryptoPriceGraph";
import { useTranslation } from "react-i18next";

const CryptoPrice = () => {
  const { t } = useTranslation();
  const [tab, setTab] = useState("24h");
  const tabs = ["24h", "7d", "1m"];

  return (
    <CryptoPriceSection>
      <CryptoPriceHeader>
        <Text size={16} style={{ fontWeight: "600" }}>
          {t("priceChangeDistribution")}
        </Text>
        <MarketTrendTabs tab={tab} setTab={setTab} tabs={tabs} />
      </CryptoPriceHeader>
      <CryptoPriceGraph />
    </CryptoPriceSection>
  );
};

export default React.memo(CryptoPrice);
